const validatorMixin = {

    data() {

        return {
            
            messagesOverride: { 
              required: "You must fill the {attribute} field to continue",
              minLength: "TEST"
            }

        };

    },

    mounted() {

        // // Reglas personalizadas
        // Validator.register('array_min', (value, requirement) => value.length >= requirement,

        //     'El campo :attribute debe tener :array_min o más elementos');

    },

    methods: {

        validationMessage(obj) {

            const model = obj.$errors[0];            
            const validator = model.$validator;

            let message = '';

            switch (validator) {

                case 'required': message = 'El campo es requerido'; break;

                case 'minLength': message = `El campo debe tener mínimo ${model.$params.min} carácteres`; break;
                case 'sameAsPassword':
                case 'sameAs': message = 'Las contraseñas deben coincidir'; break;

                case 'diferentAsPassword': message = 'La nueva contraseña debe ser distinta a la actual.'; break;

                default: message =  model.$message; break;

            }

            return message;
            
        },

    },

};

export default validatorMixin;
